import React from 'react';
import ReactDOM from 'react-dom';
import 'normalize.css';
import 'assets/styles/index.scss';
import App from './components/App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);

// Service worker volontairement désactivé : il servait les anciens bundles
// (index.html + JS) depuis son cache après chaque mise à jour, ce qui
// obligeait les utilisateurs à faire un Ctrl+F5.
// `unregister()` supprime aussi un service worker déjà installé dans le
// navigateur (migration transparente des utilisateurs existants).
serviceWorkerRegistration.unregister();
